'use strict';

var $ = require('jquery');
var carousel = require('../../components/carousel');

/**
 * @description Creates product recommendation carousel using jQuery jcarousel plugin
 */
module.exports = function () {
    $('#notempty');
    carousel.init();
};
